import { createThunkEffect } from "../../../utilities/ActionUtility";
import * as SingleIsinReportEffect from "./SingleIsinReportEffect";

export const REQUEST_ALL_REPORTS = "SingleIsinReportEffect.REQUEST_ALL_REPORTS";
export const REQUEST_ALL_REPORTS_FINISHED = "SingleIsinReportEffect.REQUEST_ALL_REPORTS_FINISHED";

export function requestAllReports() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_REPORTS, SingleIsinReportEffect.requestAllReports);
    };
}

export const CREATE_REPORT_ON_BEHALF = "SingleIsinReportEffect.CREATE_REPORT_ON_BEHALF";
export const CREATE_REPORT_ON_BEHALF_FINISHED = "SingleIsinReportEffect.CREATE_REPORT_ON_BEHALF_FINISHED";

export function createReportOnBehalf(newReport) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, CREATE_REPORT_ON_BEHALF, SingleIsinReportEffect.createReportOnBehalf, newReport);
    };
}

export const UPDATE_REPORT = "SingleIsinReportEffect.UPDATE_REPORT";
export const UPDATE_REPORT_FINISHED = "SingleIsinReportEffect.UPDATE_REPORT_FINISHED";

export function updateReport(reportId, updatedReport) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, UPDATE_REPORT, SingleIsinReportEffect.updateReport, reportId, updatedReport);
    };
}

export const REQUEST_USER_REPORTS = "SingleIsinReportEffect.REQUEST_USER_REPORTS";
export const REQUEST_USER_REPORTS_FINISHED = "SingleIsinReportEffect.REQUEST_USER_REPORTS_FINISHED";

export function requestUserReports(userId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_USER_REPORTS, SingleIsinReportEffect.requestUserReports, userId);
    };
}

export const CREATE_USER_REPORT = "SingleIsinReportEffect.CREATE_USER_REPORT";
export const CREATE_USER_REPORT_FINISHED = "SingleIsinReportEffect.CREATE_USER_REPORT_FINISHED";

export function createUserReport(userId, params) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, CREATE_USER_REPORT, SingleIsinReportEffect.createUserReport, userId, params);
    };
}

export const REQUEST_USER_REPORTS_MONTHLY_SUMMARY = "SingleIsinReportEffect.REQUEST_USER_REPORTS_MONTHLY_SUMMARY";
export const REQUEST_USER_REPORTS_MONTHLY_SUMMARY_FINISHED = "SingleIsinReportEffect.REQUEST_USER_REPORTS_MONTHLY_SUMMARY_FINISHED";

export function requestUserReportsMonthlySummary(userId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_USER_REPORTS_MONTHLY_SUMMARY, SingleIsinReportEffect.requestUserReportsMonthlySummary, userId);
    };
}



